/**
 * 树形结构转列表
 * @param {*} tree 树形结构
 * @param {*} func 回调方法
 */
export function treeToList(tree, func) {
  let node
  const list = [...tree]
  while ((node = list.shift())) {
    func(node)
    node.children && list.push(...node.children)
  }
}

/**
 * 查找节点
 * @param {*} tree 树形结构
 * @param {*} func 回调方法
 * @param {*} path 节点
 * @returns 节点
 */
export function treeFindPath(tree, func, path = []) {
  if (!tree) return []
  for (const data of tree) {
    path.push(data)
    if (func(data)) return path
    if (data.children) {
      const findChildren = treeFindPath(data.children, func, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}

/**
 * 数据字典格式化
 * @param {*} dicts 字典项列表
 * @param {*} value 字典 value
 * @returns 转化后的值
 */
export function dictFormat(dicts, value) {
  var actions = []
  Object.keys(dicts).some(key => {
    if (dicts[key].dictValue === '' + value) {
      actions.push(dicts[key].dictLabel)
      return true
    }
  })
  return actions.join('')
}

/**
 * 对象扁平化
 * @param {*} data 对象
 * @returns 转化后的值
 */
export function flat(data) {
  var result = {}
  function recurse(cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur
    } else if (Array.isArray(cur)) {
      for (var i = 0, l = cur.length; i < l; i++) { recurse(cur[i], prop + '[' + i + ']') }
      if (l === 0) { result[prop] = [] }
    } else {
      var isEmpty = true
      for (var p in cur) {
        isEmpty = false
        recurse(cur[p], prop ? prop + '.' + p : p)
      }
      if (isEmpty && prop) {
        result[prop] = {}
      }
    }
  }
  recurse(data, '')
  return result
}
